import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const FooterLinkItem = ({ data }) => {
  return (
    <div className="footer-widget">
      <h3 className="text-white text-2xl sm:text-xl font-bold mb-4">
        {data.title}
      </h3>
      <div className="footer-widget-content">
        <ul className="space-y-2">
          {data.list.map((single, key) => (
            <li key={key}>
              <Link
                to={single.url}
                reloadDocument={single.label === "Contact"}
                className="text-white hover:underline block"
              >
                {single.text}
                {single?.badge && (
                  <span className="ft-badge ml-1">{single.badge}</span>
                )}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

FooterLinkItem.propTypes = {
  data: PropTypes.object,
};

export default FooterLinkItem;
